import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PremiumPage.css'; // Keep the styling for general layout

const PremiumPage = () => {
    const navigate = useNavigate();

    // Your actual bank details
    const bankDetails = {
        poste: {
            bankName: "La Poste du Togo",
            accountName: "TCHODIE RICHARD",
            accountNumber: "9800576434006000",
            swift: "SOTOTGT1XXX",
	    iban: "TG1600100198005764300692",
        },
        utb: {
            bankName: "Union Togolaise de Banque (UTB)",
            accountName: "YOUR_ACCOUNT_NAME_UTB",
            accountNumber: "YOUR_ACCOUNT_NUMBER_UTB",
            // You might add Swift/BIC, IBAN
        },
        amount: "4200 $", // Or whatever your premium price is
        currency: "$",
    };

    const handleProceedToProofSubmission = () => {
        navigate('/submit-payment-proof'); // Navigate to a new page for proof submission
    };

    return (
        <div className="premium-page-container">
            <h1>Upgrade to Premium</h1>
            <p>Unlock exclusive features and enhance your experience!</p>

            <div className="premium-features">
                <ul>
                    <li>✅ Unlimited Designs</li>
                    <li>✅ Access to Design's tool features</li>
                    <li>✅ Ai Assistant</li>
                </ul>
            </div>

            <div className="pricing-card">
                <h2>Premium Plan</h2>
                <p className="price">{bankDetails.amount} / month</p>

                <div className="payment-instructions">
                    <h3>How to Upgrade:</h3>
                    <ol>
                        <li>
                            Transfer {bankDetails.amount} to our bank account:
                            <div className="bank-info">
                                <h4>{bankDetails.poste.bankName}</h4>
                                <p><strong>Account Name:</strong> {bankDetails.poste.accountName}</p>
                                <p><strong>Account Number:</strong> {bankDetails.poste.accountNumber}</p>
								<p><strong>For International payments:</strong></p>
								<p><strong>Swift:</strong>{bankDetails.poste.swift}</p>
								<p><strong>IBAN:</strong>{bankDetails.poste.iban}</p>
                            </div>
                            <p className="note">
                                Please ensure you transfer the exact amount.
                            </p>
                        </li>
                        <li>
                            After making the transfer, click the button below to submit your payment details and a screenshot of the receipt.
                        </li>
                        <li>
                            Your account will be activated within 24-48 hours upon verification of your payment.
                        </li>
                    </ol>
                </div>

                <button
                    onClick={handleProceedToProofSubmission}
                    className="premium-button"
                >
                    I Have Paid, Submit Proof
                </button>
            </div>
        </div>
    );
};

export default PremiumPage;